<template>
  <multipane class="vertical-panes" layout="vertical">
    <div class="pane" :style="{ width: '70%' }">
      <template v-if="$store.state.anzahl===1">
        <current style="height: 100%" keypress="Space"/>
      </template>
      <template v-if="$store.state.anzahl===2">
        <multipane layout="horizontal" style="height: 100%;">
          <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
            <current style="height: 100%" keypress="Space" />
          </div>
          <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
            <current style="height: 100%" keypress="Enter" />
          </div>
        </multipane>
      </template>
      <template v-if="$store.state.anzahl===4">
        <multipane layout="vertical" style="width: 100%; height: 100%">
          <div class="pane" :style="{ width: '50%' }">
            <multipane layout="horizontal" style="height: 100%;">
              <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
                <current style="height: 100%" keypress="Space" />
              </div>
              <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
                <current style="height: 100%" keypress="ShiftLeft" />
              </div>
            </multipane>
          </div>
          <div class="pane" :style="{ width: '50%' }">
            <multipane layout="horizontal" style="height: 100%;">
              <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
                <current style="height: 100%" keypress="Enter" />
              </div>
              <div class="pane" :style="{ height: '50%', border: '1px solid #DDDDDD' }">
                <current style="height: 100%" keypress="ShiftRight" />
              </div>
            </multipane>
          </div>
        </multipane>
      </template>
    </div>
    <multipane-resizer></multipane-resizer>
    <div class="pane" :style="{ flexGrow: 1 }">
      <besttable style="height: 100%"/>
    </div>
  </multipane>
</template>

<script>
import {Multipane, MultipaneResizer} from 'vue-multipane'
import current from '@/components/current'
import besttable from '@/components/besttable'

export default {
  name: 'home',
  components: {
    Multipane, MultipaneResizer,
    current,
    besttable
  }
}
</script>

<style>
  .vertical-panes {
    width: 100%;
    height: 100%;
  }

  .vertical-panes > .pane {
    text-align: left;
    overflow-y: scroll;
  }

  .vertical-panes > .pane ~ .pane {
    border-left: 1px solid #ccc;
  }
</style>
